var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocationIcon = function SvgLocationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "location-icon_svg__\\u5716\\u5C64_1",
    "data-name": "\\u5716\\u5C64 1",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".location-icon_svg__cls-1{fill:#fff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.22a1.62 1.62 0 1 0 1.62 1.62A1.61 1.61 0 0 0 12 8.22Z",
    className: "location-icon_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm0 18.48c-2.45-3.88-4.32-6.59-4.32-8.86a4.33 4.33 0 0 1 8.64 0c0 2.27-1.87 4.98-4.32 8.86Z",
    className: "location-icon_svg__cls-1"
  })));
};
export default SvgLocationIcon;